/** @jsxImportSource @emotion/react */
import { Route, Routes } from 'react-router-dom';
import { AffiliateUserDetails, AffiliateUserList } from './components';

export const AffiliateUsers = () => {
  return (
    <Routes>
      <Route path="/" element={<AffiliateUserList />} />
      <Route path="/:userId" element={<AffiliateUserDetails />} />
    </Routes>
  );
};
